<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">

      <template v-if="roleId <3">
        <li class="nav-item">
          <sidenav-item
            url="/dashboard"
            :class="getRoute() === 'dashboard' ? 'active' : ''"
            navText="Dashboard"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-chart-pie text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/tasks/user"
            :class="getRoute() === 'user' ? 'active' : ''"
            navText="Monitoreo"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-map text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>

        <li class="nav-item">
          <sidenav-item
            url="/tasks"
            :class="getRoute() === 'tasks' ? 'active' : ''"
            navText="Tareas"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-tasks text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>

        <li class="nav-item">
          <sidenav-item
            url="/tasks/import"
            :class="getRoute() === 'import' ? 'active' : ''"
            navText="Importar Tareas"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-plus-circle text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/tasks/my"
            :class="getRoute() === 'my' ? 'active' : ''"
            navText="Mis Tareas"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-tasks text-success text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/reports/tasks"
            :class="getRoute() === 'reports' ? 'active' : ''"
            navText="Reportes"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-file-contract text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>

        <li class="nav-item">
          <sidenav-item
            url="/clients"
            :class="getRoute() === 'clients' ? 'active' : ''"
            navText="Clientes"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-users text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>


        <li class="mt-3 nav-item">
          <h6 class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6 ms-2">Configuración</h6>
        </li>

        <li class="nav-item">
          <sidenav-item
            url="/settings/users"
            :class="getRoute() === 'users' ? 'active' : ''"
            navText="Usuarios"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-users-cog text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
         </template>
      <template v-if="roleId ===1">
        <li class="nav-item">
          <sidenav-item
            url="/settings/company"
            :class="getRoute() === 'company' ? 'active' : ''"
            navText="Empresa"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-building text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/branches"
            :class="getRoute() === 'branches' ? 'active' : ''"
            navText="Sucursales"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-map-signs
 text-primary text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
      </template>

      <template v-if="roleId === 3">
        <li class="nav-item">
          <sidenav-item
            url="/tasks/my"
            :class="getRoute() === 'my' ? 'active' : ''"
            navText="Mis Tareas"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-tasks text-success text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>

        <li class="nav-item">
          <sidenav-item
            url="/tasks/self"
            :class="getRoute() === 'self' ? 'active' : ''"
            navText="Crear Tarea"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-edit text-success text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li>

        <!--<li class="nav-item">
          <sidenav-item
            url="/profile"
            :class="getRoute() === 'profile' ? 'active' : ''"
            navText="Perfil"
            @click="toggleSidebar"
          >
            <template v-slot:icon>
              <i class="fa fa-user text-warning text-sm opacity-10"></i>
            </template>
          </sidenav-item>
        </li> -->
      </template>
      <li class="nav-item">
        <sidenav-item
          url="/lost"
          :class="getRoute() === 'company' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'التقارير' : 'Salir'"
          @click="logOut"
        >
          <template v-slot:icon>
            <i class="fa fa-times text-success text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
</template>

<script>
import SidenavItem from "./SidenavItem.vue";
import { mapMutations } from "vuex";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      isActive: "active",
      // 💡 Obtenemos el rol desde el localStorage al cargar
      roleId: parseInt(localStorage.getItem('userLevel')) || null
    };
  },
  components: {
    SidenavItem
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    ...mapMutations(["navbarMinimize"]),
    toggleSidebar() {
      this.navbarMinimize();
    },
    logOut(){
      let self = this;
      localStorage.removeItem('user');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('companyId');
      self.$router.push('/signin');
    }
  }
};
</script>